export default "__VITE_ASSET__a4949e60__"